/*
  Vehicle -> Klaviyo (storefront).
  When a shopper picks a vehicle in the PartBot garage, write it to their Klaviyo
  profile (same "Primary Vehicle ..." properties the Mechanic sync uses) and track a
  "Vehicle Added" event. Klaviyo ignores anonymous browsers, so the vehicle waits in
  localStorage and is sent on a later page view once Klaviyo knows who this is
  (email click, signup form, login, checkout). For Shopify customers, the Klaviyo
  flow "Vehicle Added: recheck Shopify" asks Mechanic to overwrite these with the
  customer's Shopify vehicle when the two differ.
*/
(function () {
  var SENT_KEY = 'kv_vehicle_sent_v1';
  var EVENT_NAME = 'Vehicle Added';
  var SPECIAL = { LANDCRUISER: 'LandCruiser', HILUX: 'HiLux', FJCRUISER: 'FJ Cruiser' };
  var script = document.currentScript;
  var customerEmail = (script && script.getAttribute('data-email')) || '';
  var busy = false;

  // Same rule as the Mechanic sync: all-caps words of 4+ plain letters are re-cased;
  // codes and trims (VDJ79R, 1VD-FTV, 4.5L, GXL+, SUV) are left alone.
  function tidyWord(w) {
    if (w.length >= 4 && w === w.toUpperCase() && w !== w.toLowerCase() && !/[0-9+\/.&()\-]/.test(w)) {
      return SPECIAL[w] || w.charAt(0) + w.slice(1).toLowerCase();
    }
    return w;
  }
  function tidy(s) {
    return String(s == null ? '' : s).trim().split(/\s+/).filter(Boolean).map(tidyWord).join(' ');
  }
  function storageGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function storageSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function readVehicle() {
    try {
      var sel = JSON.parse(storageGet('partbot_selected_vehicle') || 'null');
      return sel && sel.vehicle && sel.vehicle.make ? sel.vehicle : null;
    } catch (e) { return null; }
  }

  function build(v) {
    var series = tidy(v.series);
    if (series.indexOf('(') > -1) series = series.split('(').pop().split(')')[0].trim(); // "VDJ79R (79 Series)" -> "79 Series"
    var parts = [v.year, v.make, v.model, v.body, series, v.variant, v.engine, v.engine_capacity];
    var summary = tidy(parts.filter(function (p) { return p != null && String(p).trim() !== ''; }).join(' '));
    var profile = {
      'Primary Vehicle Series': series,
      'Primary Vehicle Summary': summary,
      'Primary Vehicle Year': String(v.year || ''),
      'Primary Vehicle Model': tidy(v.model),
      'Primary Vehicle Body': tidy(v.body),
      'Primary Vehicle Engine': tidy(v.engine)
    };
    var event = {
      'Vehicle Summary': summary,
      'Vehicle Series': series,
      'Vehicle Year': String(v.year || ''),
      'Vehicle Make': tidy(v.make),
      'Vehicle Model': tidy(v.model),
      'Vehicle Body': tidy(v.body),
      'Vehicle Variant': tidy(v.variant),
      'Vehicle Engine': tidy(v.engine),
      'Vehicle Engine Capacity': tidy(v.engine_capacity),
      'Page': location.pathname
    };
    return { profile: profile, event: event, fingerprint: summary };
  }

  function whenKlaviyo(cb, tries) {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') return cb(k);
    if ((tries || 0) > 40) return; // ~10s, then give up until the next page view
    setTimeout(function () { whenKlaviyo(cb, (tries || 0) + 1); }, 250);
  }

  function sync() {
    var v = readVehicle();
    if (!v || busy) return;
    var data = build(v);
    if (!data.fingerprint || storageGet(SENT_KEY) === data.fingerprint) return;
    busy = true;
    whenKlaviyo(function (k) {
      Promise.resolve(k.isIdentified())
        .then(function (known) {
          if (!known && !customerEmail) return; // anonymous: keep it queued for a later page view
          var props = {};
          for (var key in data.profile) props[key] = data.profile[key];
          if (!known) props.email = customerEmail;
          return Promise.resolve(k.identify(props))
            .then(function () { return k.track(EVENT_NAME, data.event); })
            .then(function () { storageSet(SENT_KEY, data.fingerprint); });
        })
        .catch(function () {})
        .then(function () { busy = false; });
    });
  }

  ['vehicle-garage-change', 'vehicle-search-change', 'plate-search-change'].forEach(function (n) {
    window.addEventListener(n, function () { setTimeout(sync, 300); });
  });
  // A Klaviyo signup form identifies the browser: send the queued vehicle straight away
  window.addEventListener('klaviyoForms', function (e) {
    if (e && e.detail && e.detail.type === 'submit') setTimeout(sync, 1500);
  });
  window.addEventListener('storage', function (e) { if (e.key === 'partbot_selected_vehicle') sync(); });
  if (document.readyState === 'complete') sync();
  else window.addEventListener('load', sync);
})();
